module.exports = __webpack_public_path__ + "static/media/264-warning-blue.77181f36.svg";